<template>
  <div
    class="container d-flex justify-content-center align-items-center mt-5"
    style="min-height: 50vh"
  >
    <div class="col-12 col-md-6 col-lg-4 align-items-center">
      <div class="border p-4 bg-light" style="border-radius: 20px">
        <div class="text-center p-2">
          <h2 style="color: black">CMS</h2>
        </div>
        <div class="text-start p-2">
          <h3 style="color: black">Login</h3>
        </div>
        <form @submit.prevent="login">
          <div class="form-group justify-content-center">
            <label for="msisdn">Phone Number</label>
            <input
              v-model="msisdn"
              class="form-control mb-3 px-2"
              type="text"
              id="msisdn"
            />

            <label for="password">Password</label>
            <input
              v-model="password"
              class="form-control mb-3 px-2"
              type="password"
              id="password"
            />
            <p class="text-danger text-center" v-if="errormessage">
              {{ errormessage }}
            </p>

            <button class="btn btn-primary w-100 px-3" type="submit">
              <span v-if="loading">Loading...</span><span v-else>Login</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../services/login";
import Cookies from "js-cookie";

export default {
  data: function () {
    return {
      loading: false,
      errormessage: "",
      msisdn: "",
      password: "",
    };
  },
  methods: {
    login() {
      if (!this.msisdn || !this.password) {
        this.$notify({
          message: "Please fill in all fields.",
          horizontalAlign: "top",
          verticalAlign: "right",
          type: "danger",
        });
        return;
      }
      this.loading = true;
      axios
        .post(
          "user/login",
          JSON.stringify({
            msisdn: parseInt(this.msisdn),
            password: this.password,
          })
        )
        .then((response) => {
        console.log("LOGIN RESPONSE",response);
          if (response.status === 200) {
            if (response.data.auth) {
              console.log(response);
              Cookies.set("authToken", response.data.auth);
              this.$notify({
                message: "Logged in successfully.",
                horizontalAlign: "top",
                verticalAlign: "right",
                type: "success",
              });
              this.$router.push({ name: "Banners", params: {} });
            }
          }
        })
        .catch((error) => {
          console.log(error);
          if (error.status == 422) {
            this.errormessage = error.response.data.error_message;
          } else {
            this.$notify({
              message: error.response.data.error_message,
              horizontalAlign: "top",
              verticalAlign: "right",
              type: "danger",
            });
          }
          console.error("Error logging in the user", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
